import { defineMessages } from 'react-intl';

export default defineMessages({
  toggleVisibility: {
    id: 'passwordInput.toggleVisibility',
    defaultMessage: 'Toggle visibility',
  },
});
